import { properties } from "@repoflow/common/schema-fields";
import {
  keyId,
  description,
  keySecret,
  roles,
} from "@common/schema/key/fields";

export default [
  {
    id: "/Public/Key",
    type: "object",
    properties: {
      ...properties, 
      keyId, 
      description,
      keySecret,
      roles,
    },
  },
  {
    id: "/Public/Key/Create",
    type: "object",
    properties: {
      roles,
      description
    },
    // `KeyInputCreate.roles` is `[String]!` in the SDL and was optional here.
    // The SDL is the contract, so the JSON Schema follows it — tablews' half of
    // P13; auth-repoflow's copy has the same gap.
    //
    // Nothing validates what the role STRINGS may be, deliberately: the role
    // set is undecided platform-wide (T2.1 / P10) and inventing one here would
    // be the decision rather than the fix.
    required: ["roles"],
  },
];
